/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourtHearingClientResponse
 */
export interface CourtHearingClientResponse {
    /**
     * 
     * @type {string}
     * @memberof CourtHearingClientResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof CourtHearingClientResponse
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CourtHearingClientResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CourtHearingClientResponse
     */
    lastName: string;
}

/**
 * Check if a given object implements the CourtHearingClientResponse interface.
 */
export function instanceOfCourtHearingClientResponse(value: object): value is CourtHearingClientResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function CourtHearingClientResponseFromJSON(json: any): CourtHearingClientResponse {
    return CourtHearingClientResponseFromJSONTyped(json, false);
}

export function CourtHearingClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtHearingClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'caseNumber': json['caseNumber'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function CourtHearingClientResponseToJSON(json: any): CourtHearingClientResponse {
    return CourtHearingClientResponseToJSONTyped(json, false);
}

export function CourtHearingClientResponseToJSONTyped(value?: CourtHearingClientResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'caseNumber': value['caseNumber'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

